import moment from 'moment'

export const helper = {
    strDecode(str) {
        return atob(str);
    },
    strEncode(str) {
        return btoa(str);
    },
    getUserObject(str){
        return JSON.parse(this.strDecode(str)); 
    }
}

export const getLocalTenant = () => {
    const userStr = localStorage.getItem("idtenant");

    if(!userStr) {
        return null;
    }

    return userStr;
}

const getConvertDate = (date, formats) => {
    return moment(date).format(formats);  
}

export const createUniqName = () => {
    const getDateNow = getConvertDate(new Date(), 'YYYY-MM-DD').replace(/-/g, '');
    const randomNumber = Math.floor(Math.random() * 1000);
    const endRandomNumber = Math.floor(Math.random() * 10000000);
    const newNumber = randomNumber.toString().padStart(4, '0');
    const endNewNumber = endRandomNumber.toString().padStart(8, '0');
  
    const combineAll = `${newNumber}_${getDateNow}-${endNewNumber}`;
    return combineAll.toString();
  }